import React from 'react'
import '../../../assets/react-toolbox/theme.css';
import theme from '../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import ListItem from "react-toolbox/lib/list/ListItem";
import List from "react-toolbox/lib/list/List";
import CheckBox from "react-toolbox/lib/checkbox/Checkbox";
import ListSubHeader from "react-toolbox/lib/list/ListSubHeader";
import ListDivider from "react-toolbox/lib/list/ListDivider";
import {bindActionCreators} from "redux";
import * as PollutionAreasActions from "../../../actions/pollutionAreas";
import connect from "react-redux/es/connect/connect";


let layersState = [];

const handleCheckBoxChange = (field, changeLayer) => {
    let auxChecked = layersState;

    auxChecked[field].check = !layersState[field].check;

    layersState = auxChecked;

    changeLayer(auxChecked);
};

const renderList = (changeLayer) => {
    return layersState.map((value, index) => {
        return (<ListItem
            key={'layer_' + value.layer}
            caption={value.layer}
            className={value.check ? 'Layerlist selected' : 'Layerlist'}
            rightActions={[
                <CheckBox
                    key={'check_' + value.layer}
                    className={'nodeListCheckBox'}
                    checked={value.check}
                />
            ]}
            onClick={() => handleCheckBoxChange(index, (layers) => changeLayer(layers))}
        />)
    });
};

const LayerSelector = props => {
    layersState = props.pollutionAreas.layers;

    return (
        <ThemeProvider theme={theme}>
            <div className="row LayerSelector">
                <List selectable ripple>
                    <ListSubHeader className="Layerlist" caption="Layers"/>
                    <ListDivider/>
                    {renderList(props.pollutionAreasActions.changeLayer)}
                </List>
            </div>
        </ThemeProvider>
    )
};

const mapStateToProps = (state) => {
    return {
        pollutionAreas: state.pollutionAreas,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        pollutionAreasActions: bindActionCreators(PollutionAreasActions, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LayerSelector)


// WEBPACK FOOTER //
// ./src/components/Map/BettAppBar/LayerSelector.js